import { render, staticRenderFns } from "./PhotoUploadForm.vue?vue&type=template&id=745da39f&scoped=true"
import script from "./PhotoUploadForm.vue?vue&type=script&lang=js"
export * from "./PhotoUploadForm.vue?vue&type=script&lang=js"
import style0 from "./PhotoUploadForm.vue?vue&type=style&index=0&id=745da39f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745da39f",
  null
  
)

export default component.exports